import { ReactElement } from 'react';
import {
  IconButton as ToqioIconButton,
  IconButtonProps as ToqioIconButtonProps,
  SIZE,
  BUTTON_VARIANTS
} from '@toqio/toqio-web-components';

import { VariantIconButtonProps } from './icon-button.types';

/**
 * TOQIO ICON BUTTON - no exportable
 * use specific components for different variants instead
 */
const IconButton = ({
  name,
  onClick,
  variant,
  type,
  disabled = false,
  size = SIZE.M,
  backgroundColor = '',
  borderColor = '',
  color = '',
  ...rest
}: ToqioIconButtonProps): ReactElement => {
  return (
    <ToqioIconButton
      name={name}
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      size={size}
      type={type}
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      color={color}
      {...rest}
    />
  )
}

export const PrimaryIconButtonXS = ({ ...props}: VariantIconButtonProps): ReactElement => {
  return (
    <IconButton
      {...props}
      variant={BUTTON_VARIANTS.PRIMARY}
      size={SIZE.XS}
    />
  )
}

export const PrimaryIconButtonS = (props: VariantIconButtonProps): ReactElement => {
  return (
    <IconButton
      {...props}
      variant={BUTTON_VARIANTS.PRIMARY}
      size={SIZE.S}
    />
  )
}

export const PrimaryIconButtonM = (props: VariantIconButtonProps): ReactElement => {
  return (
    <IconButton
      {...props}
      variant={BUTTON_VARIANTS.PRIMARY}
      size={SIZE.M}
    />
  )
}

export const SecondaryIconButtonXS = (props: VariantIconButtonProps): ReactElement => {
  return (
    <IconButton
      {...props}
      variant={BUTTON_VARIANTS.SECONDARY}
      size={SIZE.XS}
    />
  )
}

export const SecondaryIconButtonS = (props: VariantIconButtonProps): ReactElement => {
  return (
    <IconButton
      {...props}
      variant={BUTTON_VARIANTS.SECONDARY}
      size={SIZE.S}
    />
  )
}

export const SecondaryIconButtonM = (props: VariantIconButtonProps): ReactElement => {
  return (
    <IconButton
      {...props}
      variant={BUTTON_VARIANTS.SECONDARY}
      size={SIZE.M}
    />
  )
}

export const AccentIconButtonXS = (props: VariantIconButtonProps): ReactElement => {
  return (
    <IconButton
      {...props}
      variant={BUTTON_VARIANTS.ACCENT}
      size={SIZE.XS}
    />
  )
}

export const AccentIconButtonS = (props: VariantIconButtonProps): ReactElement => {
  return (
    <IconButton
      {...props}
      variant={BUTTON_VARIANTS.ACCENT}
      size={SIZE.S}
    />
  )
}

export const AccentIconButtonM = (props: VariantIconButtonProps): ReactElement => {
  return (
    <IconButton
      {...props}
      variant={BUTTON_VARIANTS.ACCENT}
      size={SIZE.M}
    />
  )
}

export const CriticalIconButtonXS = (props: VariantIconButtonProps): ReactElement => {
  return (
    <IconButton
      {...props}
      variant={BUTTON_VARIANTS.CRITICAL}
      size={SIZE.XS}
    />
  )
}

export const CriticalIconButtonS = (props: VariantIconButtonProps): ReactElement => {
  return (
    <IconButton
      {...props}
      variant={BUTTON_VARIANTS.CRITICAL}
      size={SIZE.S}
    />
  )
}

export const CriticalIconButtonM = (props: VariantIconButtonProps): ReactElement => {
  return (
    <IconButton
      {...props}
      variant={BUTTON_VARIANTS.CRITICAL}
      size={SIZE.M}
    />
  )
}